import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const LOGO_URL = "/kf-logo.png";

const footerLinks = [
  {
    title: "Company",
    links: [
      { label: "About Us", path: "/about" },
      { label: "Capabilities", path: "/capabilities" },
      { label: "Our Process", path: "/process" },
      { label: "Global Presence", path: "/global-presence" },
    ],
  },
  {
    title: "Products",
    links: [
      { label: "Unstitched Suits", path: "/products" },
      { label: "Printed Fabrics", path: "/products" },
      { label: "Embroidered Textiles", path: "/products" },
      { label: "Ready Garments", path: "/products" },
    ],
  },
];

const contactItems = [
  { icon: MapPin, value: "Surat, Gujarat, India", align: "items-start", iconCls: "mt-0.5" },
  { icon: Phone, value: "+91 6355402541", align: "items-center", iconCls: "" },
  { icon: Mail, value: "info@kfprints.com", align: "items-center", iconCls: "" },
];

const FooterBrand = () => (
  <div className="lg:col-span-1">
    <img src={LOGO_URL} alt="KF Prints" className="h-[55px] w-auto mb-6 brightness-0 invert" />
    <p className="text-sm leading-relaxed text-white/60 font-sans">
      75+ years of textile excellence. Combining heritage craftsmanship with modern manufacturing.
    </p>
  </div>
);

const FooterLinkColumn = ({ col }) => (
  <div>
    <h4 className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-6">{col.title}</h4>
    <ul className="space-y-3">
      {col.links.map((link) => (
        <li key={link.label}>
          <Link to={link.path} className="text-sm font-sans text-white/60 hover:text-white transition-colors duration-200">
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div>
    <h4 className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-6">Contact</h4>
    <ul className="space-y-4">
      {contactItems.map(({ icon: Icon, value, align, iconCls }) => (
        <li key={value} className={`flex ${align} gap-3`}>
          <Icon size={16} className={`text-[#C5A059] flex-shrink-0 ${iconCls}`} />
          <span className="text-sm font-sans text-white/60">{value}</span>
        </li>
      ))}
    </ul>
  </div>
);

const FooterBottomBar = () => (
  <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
    <p className="text-xs font-sans text-white/40">
      &copy; {new Date().getFullYear()} KF Prints (Krish Fashion). All rights reserved.
    </p>
    <div className="flex items-center gap-6">
      <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs font-sans text-white/30 hover:text-white/60 transition-colors duration-200">
        Admin
      </Link>
    </div>
  </div>
);

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0F172A] text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <FooterBrand />
          {footerLinks.map((col) => <FooterLinkColumn key={col.title} col={col} />)}
          <FooterContact />
        </div>
        <FooterBottomBar />
      </div>
    </footer>
  );
}
